import * as React from 'react'
import { Text as RNText, View, StyleSheet } from 'react-native'
import { descriptionGray } from '@themes/Colors'
import Fonts from '@themes/Fonts'

export function Text({
  text,
  numberOfLines,
}: {
  text?: string
  numberOfLines?: number
}): JSX.Element {
  return (
    <View>
      {!!text && (
        <RNText numberOfLines={numberOfLines} style={styles.descriptionText}>
          {text}
        </RNText>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  descriptionText: {
    fontFamily: Fonts.type.regular,
    fontSize: 15,
    color: descriptionGray,
    paddingBottom: 4,
    lineHeight: 22,
  },
})
